import { timeLeft, currencyFormat } from '_helpers';
import * as moment from 'moment';

// Subevent needs attention
function subEventNeedsAttention(traitStatus) {
  // [TraitStatus] for subEvent
  // console.log("traitstatus", traitStatus)
  let needsAttention = 0
  traitStatus.forEach(ts => {
    if ((ts.req > ts.bid.length ||
      ts.req > ts.num_ok) && ts.req !== ts.booked.length) {
      needsAttention += 1
    }
  });
  return needsAttention
}

// SubEvents in Event need attention
export function subEventsNeedAttention(event, sbTraitStatus) {
  let numSubEvents = 0
  let okSubEvents = 0
  // console.log("subEventsNeedAttention", event.event_name, sbTraitStatus)
  if (event.sb_event) {
    Object.entries(event.sb_event).forEach(([sbId, sb_event]) => {
      numSubEvents += 1
      if (sbTraitStatus.hasOwnProperty(sbId)) {
        okSubEvents += (subEventNeedsAttention(sbTraitStatus[sbId]) === 0) ? 1 : 0
      }
    })
  }
  // return {okSubEvents, numSubEvents}
  return okSubEvents < numSubEvents
}



export function businessBidStatusMessage(bid, slotFull) {
  // State: { Request, Bid, Booked, Rejected, Reversed, Cancelled, InsufficientFunds }
  // BidState: { Win, Lose, Fatal, NA}
  const state = bid.state
  const bidState = bid.bid_state
  const auction_end_time = bid.auction_end_time
  const auction_run_time = bid.auction_run_time
  const streamlineMode = bid.is_auction === 0
  const auctionStatus = timeLeft(auction_end_time)
  const now = moment()
  const auctionEndTime = moment(auction_end_time)
  const auctionRunTime = moment(auction_run_time)
  const withinProcessingPeriod = !streamlineMode && now.isAfter(auctionEndTime) && (now.isBefore(auctionRunTime))


  switch (state) {
    case 'Request':
      if (auctionStatus === 'Schedule Closed') {
        return 'Expired'
      }
      return slotFull ? 'Offer Sent\n(Slot Full)' : 'Offer Sent'
    case 'Bid':
      if (auctionStatus === 'Schedule Closed') {
        if (withinProcessingPeriod) {
          return 'Processing'
        } else {
          return streamlineMode ? "Expired" : 'Lost'
        }
      }
      if (bidState === 'Win') {
        return slotFull ? streamlineMode ? 'Offer Sent\n(Slot Full)' : 'Slot Full' : streamlineMode ? "Offer Sent" : 'Leading'
      } else if (bidState === 'Fatal') {
        return streamlineMode ? "Time Conflict" : 'Lost'
      } else if (bidState === 'Lose') {
        return slotFull ? streamlineMode ? 'Offer Sent\n(Slot Full)' : 'Slot Full' : streamlineMode ? "Offer Sent" : 'Losing'
      }
      break;
    case 'Booked':
      return `Booked: ${currencyFormat(bid.country, bid.amount)}`
    case 'Rejected':
      return streamlineMode ? "Offer Rejected" : 'Bid Rejected'
    case 'Reversed':
      return 'Booking Reversed'
    case 'Cancelled':
      return streamlineMode ? 'Offer Cancelled' : 'Bid Cancelled'
    case 'InsufficientFunds':
      return 'Insufficient Funds'
    default:
      return ''
  }
}

export function businessBidSort(left, right) {
  const bidSort = {
    Booked: 7,
    Bid: 6,
    Request: 5,
    Reversed: 4,
    Cancelled: 3,
    InsufficientFunds: 2,
    Rejected: 1,
  }
  const leftState = bidSort[left.state] ? bidSort[left.state] : 0
  const rightState = bidSort[right.state] ? bidSort[right.state] : 0
  console.log("leftState", leftState, left.state)
  console.log("rightState", rightState, right.state)
  return rightState - leftState
}

export function allowBookEarly(state, bidState, auction_end_time) {
  const auctionStatus = timeLeft(auction_end_time)
  switch (state) {
    case 'Bid':
      if (auctionStatus === 'Schedule Closed') {
        return false
      }
      if (bidState === 'Win') {
        return true
      } else if (bidState === 'Fatal') {
        return false
      } else if (bidState === 'Lose') {
        return true
      }
    default:
      return false
  }
}

export function celebBidStatusMessage(spcEvent, mode, isAuction) {
  // State: { Request, Bid, Booked, Rejected, Reversed, Cancelled, InsufficientFunds }
  // BidState: { Win, Lose, Fatal, NA}
  // mode: "Detailed", "Abbreviated", "Schedule"
  const streamlineMode = !isAuction
  const state = spcEvent.state
  const bidState = spcEvent.bid_state
  const auction_end_time = spcEvent.auction_end_time
  const auction_run_time = spcEvent.auction_run_time


  const auctionStatus = timeLeft(auction_end_time)
  const now = moment()
  const auctionEndTime = moment(auction_end_time)
  const auctionRunTime = moment(auction_run_time)
  const withinProcessingPeriod = now.isAfter(auctionEndTime) && (now.isBefore(auctionRunTime))
  // const offerPrice = !isAuction ? currencyFormat(spcEvent.country, spcEvent.price) : ""

  switch (state) {
    case 'Request':
      if (auctionStatus === 'Schedule Closed') {
        if (mode === "Detailed") return streamlineMode ? "This booking offer has expired because your schedule is closed." : 'This bid request has expired because your schedule is closed.' //Detailed
        if (mode === "Abbreviated") return streamlineMode ? "Expired Booking Offer" : 'Expired Bid Request' //Abbreviated
        if (mode === "Schedule") return 'Expired' //Schedule
      } else {
        if (mode === "Detailed") return 'Incoming Booking Offer.' //Detailed--String Match Line 947 Celeb Event
        if (mode === "Abbreviated") return streamlineMode ? "Booking Offer" : 'Bid Request' //Abbreviated
        if (mode === "Schedule") return streamlineMode ? 'Offer' : 'Request' //Schedule
      }
      break;
    case 'Bid':
      if (auctionStatus === 'Schedule Closed') {
        if (withinProcessingPeriod) {
          if (mode === "Detailed") return streamlineMode ? "This booking offer has expired because your schedule is closed." : "This bid is currently processing. We'll let you know soon!" //Detailed
          if (mode === "Abbreviated") return streamlineMode ? "Offer Expired" : 'Processing' //Abbreviated
          if (mode === "Schedule") return streamlineMode ? "Offer Expired" : 'Processing' //Schedule
        } else {
          if (mode === "Detailed") return streamlineMode ? "Offer Expired" : 'Schedule Closed. This bid has lost.' //Detailed
          if (mode === "Abbreviated") return streamlineMode ? "Offer Expired." : 'Bid Lost' //Abbreviated
          if (mode === "Schedule") return streamlineMode ? "Offer Expired" : 'Bid Lost' //Schedule
        }

      }
      if (bidState === 'Win') {
        if (mode === "Detailed") return streamlineMode ? 'Incoming Booking Offer.' : 'This bid is currently leading.' //Detailed
        if (mode === "Abbreviated") return streamlineMode ? "Booking Offer" : 'Active Bid' //Abbreviated
        if (mode === "Schedule") return streamlineMode ? 'Offer' : 'Active Bid' //Schedule
      } else if (bidState === 'Fatal') {
        if (mode === "Detailed") return streamlineMode ? "This booking offer has a time-conflict with another booking." : 'This bid has lost due to a time-conflict with another booking.' //Detailed
        if (mode === "Abbreviated") return "Time Conflict"
        if (mode === "Schedule") return 'Time Conflict' //Schedule
      } else if (bidState === 'Lose') {
        if (mode === "Detailed") return streamlineMode ? 'Incoming Booking Offer.' : 'This bid is currently losing.' //Detailed
        if (mode === "Abbreviated") return streamlineMode ? "Booking Offer" : 'Active Bid' //Abbreviated
        if (mode === "Schedule") return streamlineMode ? 'Offer' : 'Active Bid' //Schedule
      }
      break;
    case 'Booked':
      if (mode === "Detailed") return 'Booked' //Detailed
      if (mode === "Abbreviated") return 'Booked' //Abbreviated
      if (mode === "Schedule") return 'Booked' //Schedule
      break;
    case 'Rejected':
      if (mode === "Detailed") return streamlineMode ? "You rejected this booking." : 'You rejected this bid.' //Detailed
      if (mode === "Abbreviated") return streamlineMode ? "Booking Rejected" : 'Bid Rejected' //Abbreviated
      if (mode === "Schedule") return 'Rejected' //Schedule
      break;
    case 'Reversed':
      if (mode === "Detailed") return 'This booking was refunded.' //Detailed
      if (mode === "Abbreviated") return 'Booking Refunded'  //Abbreviated
      if (mode === "Schedule") return 'Refunded' //Schedule
      break;
    case 'Cancelled':
      if (mode === "Detailed") return streamlineMode ? "This offer was cancelled." : 'This bid was cancelled.' //Detailed
      if (mode === "Abbreviated") return streamlineMode ? "Offer Cancelled" : 'Bid Cancelled' //Abbreviated
      if (mode === "Schedule") return 'Cancelled' //Schedule
      break;
    case 'InsufficientFunds':
      if (mode === "Detailed") return streamlineMode ? "Payment Error" : 'This bid has lost.'  //Detailed
      if (mode === "Abbreviated") return streamlineMode ? "Payment Error" : 'Inactive Bid' //Abbreviated
      if (mode === "Schedule") return ' '  //Schedule
      break;
    default:
      return ''
  }
}

export function celebBidStatusColor(spcEvent) {
  // State: { Request, Bid, Booked, Rejected, Reversed, Cancelled, InsufficientFunds }
  // BidState: { Win, Lose, Fatal, NA}
  const state = spcEvent.state
  const bidState = spcEvent.bid_state
  const auction_end_time = spcEvent.auction_end_time
  const auction_run_time = spcEvent.auction_run_time

  const auctionStatus = timeLeft(auction_end_time)
  const now = moment()
  const auctionEndTime = moment(auction_end_time)
  const auctionRunTime = moment(auction_run_time)
  const isAuction = spcEvent.is_auction === 1
  const withinProcessingPeriod = isAuction && now.isAfter(auctionEndTime) && (now.isBefore(auctionRunTime))
  switch (state) {
    case 'Request':
      if (auctionStatus === 'Schedule Closed') {
        return 'text-gray' //schedule Over
      }
      return 'text-purple' //Show Buttons
    case 'Bid':
      if (auctionStatus === 'Schedule Closed') {
        if (withinProcessingPeriod) {
          return 'text-info'  //Processing
        } else {
          return 'text-gray'  //schedule Over
        }
      } else if (bidState === 'Win') {
        return isAuction ? 'text-info' : 'text-purple' //
      } else if (bidState === 'Fatal') {
        return 'text-danger'
      } else if (bidState === 'Lose') {
        return isAuction ? 'text-info' : 'text-purple'
      }
      break;
    case 'Booked':
      return 'text-primary'
    case 'Rejected':
      return ''
    case 'Reversed':
      return ''
    case 'Cancelled':
      return 'text-danger'
    case 'InsufficientFunds':
      return 'text-danger'
    default:
      return ''
  }
}

export function celebBidStatusBackground(spcEvent) {
  // State: { Request, Bid, Booked, Rejected, Reversed, Cancelled, InsufficientFunds }
  // BidState: { Win, Lose, Fatal, NA}
  const state = spcEvent.state
  const bidState = spcEvent.bid_state
  const auction_end_time = spcEvent.auction_end_time
  const auction_run_time = spcEvent.auction_run_time

  const auctionStatus = timeLeft(auction_end_time)
  const now = moment()
  const auctionEndTime = moment(auction_end_time)
  const auctionRunTime = moment(auction_run_time)
  const isAuction = spcEvent.is_auction === 1
  const withinProcessingPeriod = isAuction && now.isAfter(auctionEndTime) && (now.isBefore(auctionRunTime))
  switch (state) {
    case 'Request':
      if (auctionStatus === 'Schedule Closed') {
        return 'bg-darkMode white-box-shadow' //schedule Over
      }
      return 'bg-purple purple-box-shadow-pulse' //Show Buttons
    case 'Bid':
      if (auctionStatus === 'Schedule Closed') {
        if (withinProcessingPeriod) {
          return 'bg-gradient-cyan teal-box-shadow-pulse'  //Processing
        } else {
          return 'bg-darkMode white-box-shadow'  //schedule Over
        }
      }
      if (bidState === 'Win') {
        return isAuction ? 'bg-gradient-cyan teal-box-shadow-pulse' : 'bg-purple purple-box-shadow-pulse'
      } else if (bidState === 'Fatal') {
        return 'bg-danger red-box-shadow'
      } else if (bidState === 'Lose') {
        return isAuction ? 'bg-gradient-cyan teal-box-shadow-pulse' : 'bg-purple purple-box-shadow-pulse'
      }
      break;
    case 'Booked':
      return 'bg-primary livenyte-box-shadow-pulse'
    case 'Rejected':
      return 'bg-darkMode white-box-shadow'
    case 'Reversed':
      return 'bg-darkMode black-box-shadow '
    case 'Cancelled':
      return 'bg-danger red-box-shadow'
    case 'InsufficientFunds':
      return 'bg-danger red-box-shadow'
    default:
      return ''
  }
}

export function getBidStateNotificationColor(bidState, bidStatus, evEndTime, auction_end_time, auction_run_time) {
  const now = moment()
  const isAuctionClosed = now.isSameOrAfter(auction_end_time)
  const auctionEndTime = moment(auction_end_time)
  const auctionRunTime = moment(auction_run_time)
  const withinProcessingPeriod = now.isAfter(auctionEndTime) && (now.isBefore(auctionRunTime))
  const isPastEvent = now.isSameOrAfter(evEndTime)
  let selectedColor = "text-gray"
  switch (bidState) {
    case "Request":
      selectedColor = isAuctionClosed ? 'text-gray' : "text-purple";
      break;
    case "Bid":
      if (isAuctionClosed) {
        if (withinProcessingPeriod) {
          selectedColor = "text-info";
        } else {
          selectedColor = "text-gray";
        }
      } else {
        switch (bidStatus) {
          case "Win":
            selectedColor = "text-info";
            break;
          case "Fatal":
            selectedColor = "text-danger";
            break;
          case "Lose":
            selectedColor = "text-info";
            break;
          default:
            selectedColor = "";
        }
      }
      break;
    case "Booked":
      selectedColor = "text-primary";
      break;
    case "Rejected":
      selectedColor = '';
      break;
    case "Reversed":
      selectedColor = '';
      break;
    case "Cancelled":
      selectedColor = 'text-danger';
      break;
    case "InsufficientFunds":
      selectedColor = "text-danger";
      break;
    default:
      selectedColor = "text-default";
  }
  const str = `surtitle ${selectedColor}`
  console.log("getBidStateNotificationColor", str)
  return str
}

export function paymentStateColor(state) {
  // case Charged
  // case Pending
  // case Dispute
  // case Completed
  // case Reversed
  const prefersDark = localStorage.getItem("darkMode") === "true";

  switch (state) {
    case 'Charged':
      return 'text-info'
    case 'Pending':
      return 'text-gray'
    case 'Dispute':
      return 'text-danger'
    case 'Completed':
      return 'text-success'
    case 'Reversed':
      return prefersDark ? 'text-white' : 'text-dark'
    default:
      return ''
  }
}

export function paymentStateDescription(state) {
  // case Charged
  // case Pending
  // case Dispute
  // case Completed
  // case Reversed

  switch (state) {
    case 'Reversed':
      return 'Refunded'
    default:
      return state
  }
}




export function traitStatusForEvents(stateSbTraitStatus, events) {

  let sbTraitStatus = {}  // {  sbEventID: TraitStatus }
  if (stateSbTraitStatus) {
    sbTraitStatus = Object.assign({}, stateSbTraitStatus)
  }
  const user = JSON.parse(localStorage.getItem('user'));
  events.forEach(event => {
    // console.log("traitStatusForEvents", Object.entries(event.sb_event).length)
    if (event.business_id === user.user_id && (event.sb_event !== undefined && event.sb_event !== null && Object.entries(event.sb_event).length > 0)) {
      // console.log("traitStatusForEvents", event)
      Object.entries(event.sb_event).forEach(([sbId, sb_event]) => {
        console.log("event", event.event_name)
        let traitStatus = []
        Object.entries(sb_event.traits_num).forEach(([trait, num]) => {
          traitStatus.push(
            {
              name: trait,
              req: num,
              booked: [],
              bid: [],
              num_ok: 0
            })
        })
        Object.entries(sb_event.bids).forEach(([bidId, bid]) => {
          let trait = bid.sp_trait
          let pos = traitStatus.findIndex(ts => ts.name === trait)
          if (bid.bid_state === 'Win') {
            traitStatus[pos].num_ok += 1
          }
          if (bid.state === 'Booked') {
            traitStatus[pos].booked.push(bidId)
          } else {
            traitStatus[pos].bid.push(bidId)
          }

        })
        sbTraitStatus[sbId] = traitStatus
      })
    }
  })
  return sbTraitStatus
}

export function getTicketsRemaining(quantity, num_sold, num_refunded) {
  const numRemaining = quantity - num_sold + num_refunded

  if (numRemaining > -1) {
    return numRemaining
  } else {
    return 0
  }

}

export function getSchRequestColor(state) {
  switch (state) {
    case 'CREATED':
      return 'text-success'
    case 'REJECTED':
      return 'text-danger'
    case 'PENDING':
      return 'text-info'
      return ''
  }
}

export function eventHasNewMessages(eventMessagesMap, eventId) {
  const messageGroups = eventMessagesMap[eventId];
  const test = messageGroups && messageGroups.some(message => message.length >= 5 && ((message[1] === false) && (message[4] === true))
  )
  return test

}

export function filterSpecialistsFromScheduleRequests(sb_event_id, specialists_nosch, _businessScheduleRequests) {
  // Collect the sp_info.id values for the given sb_event_id
  const businessScheduleRequests = _businessScheduleRequests ? _businessScheduleRequests : []
  const existingIds = new Set(
    (businessScheduleRequests[sb_event_id] || []).map(req => req.sp_info.id)
  );

  // Filter specialists_nosch to only keep those not already in existingIds
  return specialists_nosch.filter(sp => !existingIds.has(sp.sp_id));
}

export function guestsToCSV(guests) {
  // Filter out TapToPay internal email
  const filtered = guests.filter(g => g.email !== "taptopay@livenyte.com");

  // Map to CSV rows: name,email
  const rows = filtered.map(g => `${g.name},${g.email},${g.ticket_id},${g.ticket_name},${g.quantity},${g.checked_in}`);

  // Add header row
  return ["name,email,order_id,ticket,qty,checked_in", ...rows].join("\n");
}

export function downloadCSV(csv, filename) {
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}